import { render, staticRenderFns } from "./Rgpd.vue?vue&type=template&id=10b2ddc7&scoped=true"
import script from "./Rgpd.vue?vue&type=script&lang=js"
export * from "./Rgpd.vue?vue&type=script&lang=js"
import style0 from "./Rgpd.vue?vue&type=style&index=0&id=10b2ddc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b2ddc7",
  null
  
)

export default component.exports